import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetPriorityParams } from '../../../ts/ServerApi/types/actionParams';

export class SetRunFlowTasksPriorityRequest extends Request<ISetPriorityParams, IResult> {
  constructor(ids: string[], priority: number) {
    super('setRunFlowTasksPriority', {
      ids: ids,
      priority: priority
    });
  }
}
